import { TypePolicies } from '@apollo/client';

import { bucketGeoInFieldArgs, OffersFieldArgs, stableStringify } from './offers-cache.utils';

/**
 * The query passes precise lat/lng to the server (so results are accurate), but we want
 * sessions at the same physical location to share one Apollo cache slot. Without bucketing,
 * GPS jitter produces a different cache key on every cold start and the persisted offers
 * cache can never warm Apollo.
 *
 * Buckets only the cache key — args sent to the server are unaffected. Aligned with the
 * localforage key built by `bucketGeoInQueryVariables`.
 */
export const offersTypePolicy: TypePolicies = {
  Membership: {
    fields: {
      offers: {
        keyArgs: (args) => (args ? stableStringify(bucketGeoInFieldArgs(args as OffersFieldArgs)) : false),
      },
    },
  },
};
